export default {
	Regular: 'regular',
	Parent: 'parent',
	Junior: 'junior',
};
